import React from 'react';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {
  MODALS,
  fetchBooking,
  fetchKycs,
  fetchAgreements,
  fetchAffordabilities
} from 'ducks/bookings';

import {AddSecondaryTenantForm} from './components';
import './styles.css';

class AddSecondaryTenantModal extends React.Component<any> {
  getExtraActions = () => {
    const {data: {locationRef, bookingId}} = this.props;
    return [
      () => this.props.fetchBooking({locationRef, bookingId}),
      () => this.props.fetchKycs({bookingId}),
      () => this.props.fetchAffordabilities({bookingId}),
      () => this.props.fetchAgreements({bookingId}),
      ...this.props.closeModalExtraActions
    ];
  };

  triggerSubmit = () => {
    this.props.submit('addSecondaryTenantForm');
  };

  render() {
    const {data: {form: {submitting}, bookingId}} = this.props;
    return (
      <Modal
        className="AddSecondaryTenantModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Add Secondary Tenant" />
        <Modal.Body>
          <AddSecondaryTenantForm
            bookingId={bookingId}
            getExtraActions={this.getExtraActions}
          />
        </Modal.Body>
        <Modal.Footer>
          <Modal.SubmitButtons
            submitting={submitting}
            triggerSubmit={this.triggerSubmit}
            closeModal={this.props.closeModal}
            createLabel="Add Secondary Tenant"
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = state => {
  return {
    form: {
      submitting: isSubmitting('addSecondaryTenantForm')(state)
    }
  };
};

const mapDispatchtoProps = {
  fetchBooking,
  submit,
  fetchAffordabilities,
  fetchKycs,
  fetchAgreements
};

export default withModal(
  MODALS.ADD_SECONDARY_TENANT,
  mapStateToModalData,
  mapDispatchtoProps
)(AddSecondaryTenantModal);
